export default __webpack_public_path__ + "static/media/forms.6dfbb562.svg";